import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { BaseViewComponent, IconItem, StatusKind } from '@sb/library/base';

@Component({
    selector: 'lib-status-label',
    templateUrl: './status-label.component.html',
    styleUrls: ['./status-label.component.scss']
})
export class StatusLabelComponent extends BaseViewComponent implements OnInit {
    @ViewChild('label') labelEl!: ElementRef;

    @Input() icon!: IconItem;
    @Input() kind: StatusKind = StatusKind.Neutral;
    @Input() clickable: boolean = false;
    @Input() qaTag: string = "";
    @Input() labelColor: string = "";
    @Input() showSpinner: boolean = false;
    @Input() toolTipText: string = "";
    @Input() toolTipPosition: TooltipPosition = "after";
    @Input() iconColourClass: string = "";

    @Output() clicked = new EventEmitter<void>()

    Clicked() {
        if (this.clickable) {
            this.clicked.emit();
        }
    }

    HandleKeyDown(event: KeyboardEvent): void {
        if (!this.clickable) return;

        if (event.key === 'Enter') {
            event.preventDefault();
            this.Clicked();
        } else if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
        }
    }

    HandleKeyUp(event: KeyboardEvent): void {
        if (this.clickable && (event.key === ' ' || event.key === 'Spacebar')) {
            event.preventDefault();
            this.Clicked();
        }
    }

    LabelIsTruncated(value: boolean): void {
        // if its truncated and there wasnt a tool tip text passed in, then add a tool tip of the label
        if (!this.toolTipText && value) {
            this.toolTipText = this.labelEl.nativeElement.textContent?.trim();
        }
    }
}
